<template>
	<div class="layout mx-auto my-auto bg-lightPurple">
		<div class="custom-background h-screen">
			<div class=" center-screen">
				<div class="mb-5">
					<img
						class="w-3/4 mx-auto "
						src="../../assets/dashboard/home/icon-notfound.png"
						alt="404 image"
						srcset=""
					/>
				</div>
				<div>
					<p class=" text-white font-bold text-4xl">Oops!</p>
					<p class="text-white text-2xl">
						Halaman yang kamu cari tidak ditemukan
					</p>
				</div>
				<div>
					<router-link to="/">
						<p
							class="text-center mt-3 mb-2 uppercase bg-lightPurple py-1 px-4 text-xl rounded-md text-white"
						>
							Kembali ke beranda
						</p>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.custom-background {
	background-image: url("~@/assets/dashboard/home/bg-notfound.png");
}
.center-screen {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	min-height: 100vh;
}
</style>
<script>
export default {
	name: "not-found-dashboard",
	components: {},
};
</script>
